var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefilerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.893,
    height: 184.299,
    viewBox: "0 0 4.893 184.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_210",
    "data-name": "Groupe 210",
    transform: "translate(1837.416 26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discover",
    transform: "translate(-2749.667 -396.685)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_197",
    "data-name": "Groupe 197",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_340",
    "data-name": "Trac\\xE9 340",
    d: "M912.251,370.685h2.325a2.271,2.271,0,0,1,1.693.636,2.314,2.314,0,0,1,.63,1.7v5.124a2.316,2.316,0,0,1-.63,1.7,2.275,2.275,0,0,1-1.693.636h-2.325Zm2.254,8.4a.827.827,0,0,0,.91-.909v-5.181a.828.828,0,0,0-.91-.91h-.77v7Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_198",
    "data-name": "Groupe 198",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_341",
    "data-name": "Trac\\xE9 341",
    d: "M912.587,388.685H916.8v1.4h-2.73v2.73h2.17v1.4h-2.17v2.869h2.73v1.4h-4.214Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_199",
    "data-name": "Groupe 199",
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_342",
    "data-name": "Trac\\xE9 342",
    d: "M912.671,406.685h4.144v1.4h-2.66v2.87h2.1v1.4h-2.1v4.13h-1.484Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_200",
    "data-name": "Groupe 200",
    style: {
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_343",
    "data-name": "Trac\\xE9 343",
    d: "M913.764,424.685h1.483v9.8h-1.483Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_201",
    "data-name": "Groupe 201",
    style: {
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_344",
    "data-name": "Trac\\xE9 344",
    d: "M912.679,442.685h1.483v8.4h2.646v1.4h-4.129Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_202",
    "data-name": "Groupe 202",
    style: {
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_345",
    "data-name": "Trac\\xE9 345",
    d: "M912.587,460.685H916.8v1.4h-2.73v2.73h2.17v1.4h-2.17v2.869h2.73v1.4h-4.214Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_203",
    "data-name": "Groupe 203",
    style: {
      isolation: "isolate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_346",
    "data-name": "Trac\\xE9 346",
    d: "M915.6,488.484l-1.078-4.046h-.77v4.046h-1.484v-9.8H914.6a2.271,2.271,0,0,1,1.693.636,2.314,2.314,0,0,1,.63,1.7V482.1a2.568,2.568,0,0,1-.266,1.189,1.984,1.984,0,0,1-.756.813l1.246,4.381Zm-1.848-5.446h.77a.827.827,0,0,0,.91-.91v-1.134a.828.828,0,0,0-.91-.91h-.77Z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ligne_9",
    "data-name": "Ligne 9",
    transform: "translate(-2749.667 -396.685)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 1,
    height: 56,
    transform: "translate(914.198 498.984)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefilerIcon);
export default __webpack_public_path__ + "static/media/defiler_icon.fba071ea578ae1d8792ce3ca5211dbc3.svg";
export { ForwardRef as ReactComponent };